<template>
  <v-container>
    <v-card
      flat
      class="special-shadow mb-12"
      :loading="card.loader"
      :disabled="card.disabled"
    >
      <v-toolbar flat>
        <v-avatar color="blue lighten-5" class="mr-3" size="40">
          <v-icon color="blue darken-3" size="18">
            mdi-cogs
          </v-icon>
        </v-avatar>

        <v-toolbar-title class="font-weight-medium">
          Configuración
        </v-toolbar-title>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-row class="col-lg-8 col-md-9 px-0 pa-0 mx-auto">
          <v-col cols="12">
            <v-text-field
              label="Empresa"
              outlined
              hide-details
              clearable
              type="text"
              v-model="form.empresa"
              :error="error.empresa"
              @input="error.empresa = false"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="Nit"
              outlined
              hide-details
              clearable
              type="number"
              v-model="form.nit"
              :error="error.nit"
              @input="error.nit = false"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="Dirección"
              outlined
              hide-details
              clearable
              type="text"
              v-model="form.direccion"
              :error="error.direccion"
              @input="error.direccion = false"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" xl="6">
            <v-text-field
              label="IP Datos SC"
              outlined
              hide-details
              clearable
              type="text"
              v-model="form.ip_datos_sc"
              :error="error.ip_datos_sc"
              @input="error.ip_datos_sc = false"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" xl="6">
            <v-text-field
              label="IP Datos PSC"
              outlined
              hide-details
              clearable
              type="text"
              v-model="form.ip_datos_psc"
              :error="error.ip_datos_psc"
              @input="error.ip_datos_psc = false"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="12" xl="12">
            <v-text-field
              label="Directorio de contabilidada"
              outlined
              hide-details
              clearable
              type="text"
              v-model="form.contabilidad"
              :error="error.contabilidad"
              @input="error.contabilidad = false"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              large
              color="blue darken-4"
              class="white--text"
              depressed
              @click="guardarConfiguracion"
            >
              <v-icon left>mdi-content-save-cog-outline</v-icon>
              Grabar configuración
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: 'configuracion',
  data() {
    return {
      form: {
        empresa: null,
        nit: null,
        direccion: null,
        ip_datos_sc: null,
        ip_datos_psc: null,
        contabilidad: null,
      },
      error: {
        empresa: false,
        nit: false,
        direccion: false,
        ip_datos_sc: false,
        ip_datos_psc: false,
        contabilidad: false,
      },
      card: {
        loader: false,
        disabled: false,
      },
    }
  },
  created() {
    this.get_info()
  },
  methods: {
    guardarConfiguracion() {
      var data = this.form
      if (!data.empresa) {
        this.error.empresa = true
        this.$emit('msj', 'Ingresa el nombre de la empresa')
      } else if (!data.nit) {
        this.error.nit = true
        this.$emit('msj', 'Ingresa el nit de la empresa')
      } else if (!data.direccion) {
        this.error.direccion = true
        this.$emit('msj', 'Ingresa la dirección de la empresa')
      } else if (!data.ip_datos_sc) {
        this.error.ip_datos_sc = true
        this.$emit('msj', 'Ingresa la IP del servidor de datos SC')
      } else if (!data.ip_datos_psc) {
        this.error.ip_datos_psc = true
        this.$emit('msj', 'Ingresa la IP del servidor de datos PSC')
      } else if (!data.contabilidad) {
        this.error.contabilidad = true
        this.$emit('msj', 'Ingresa el nombre de la contabilidad')
      } else {
        this.card.loader = true
        this.card.disabled = true

        var envio = {
          NOMUSU: data.empresa,
          NITUSU: data.nit,
          DIRUSU: data.direccion,
          IPUSU: data.ip_datos_sc,
          IPUSU2: data.ip_datos_psc,
          DIRCONT: data.contabilidad,
        }

        // console.log("Guardar ", envio);
        this.postData('INDEX_CONFIG', envio)
          .then((data) => {
            this.$emit('msj', 'Configuración grabada correctamente', 'success')
            this.get_info()
          })
          .catch((err) => {
            this.card.loader = false
            console.error('Error', err)
            this.$emit(
              'msj',
              'Ha ocurrido un error cargando la configuración: ' + err,
            )
          })
      }
    },
    get_info() {
      this.card.loader = true
      this.card.disabled = true
      this.postData('sc-usunet', {
        usuario: '99',
      })
        .then((data) => {
          this.card.loader = false
          this.card.disabled = false

          var datos = data.Usunet[0]
          this.form.empresa = datos.NOMUSU.trim()
          this.form.nit = datos.NITUSU.trim()
          this.form.direccion = datos.DIRUSU.trim()
          this.form.contabilidad = datos.DIRCONT.trim()
          this.form.ip_datos_sc = datos.IPUSU.trim()
          this.form.ip_datos_psc = datos.IPUSU2.trim()
        })
        .catch((err) => {
          this.card.loader = false
          console.error('Error', err)
          this.$emit(
            'msj',
            'Ha ocurrido un error cargando la configuración: ' + err,
          )
        })
    },
  },
}
</script>
